/* This is a temporary workaround because of how the naming structure 
in the tasks reducer is set up for a selected task type. Currently it's 
named "selectedActionPrediction", but this should probably be changed
to "task_type_id"  */

export default {
  1: { name: 'email', payload_name: 'send_email', colloquial: 'Send email' },
  2: { name: 'sms', payload_name: 'send_sms', colloquial: 'Send text' },
  4: {
    name: 'groupAdd',
    payload_name: 'add_contacts_to_group',
    colloquial: 'Add contacts to group',
  },
  5: {
    name: 'groupRemove',
    payload_name: 'remove_contacts_from_group',
    colloquial: 'Remove contacts from group',
  },
  6: {
    name: 'groupMove',
    payload_name: 'move_contacts_btwn_groups',
    colloquial: 'Move contacts between groups',
  },
  7: {
    name: 'reassignContact',
    payload_name: 'reassign_contact',
    colloquial: 'Reassign contact',
  },
  8: {
    name: 'removeContactFromCampaign',
    payload_name: 'remove_from_campaign',
    colloquial: 'Remove Contact from Campaign',
  },
  9: {
    name: 'httpSendData',
    payload_name: 'http_send_data',
    colloquial: 'HTTP Post',
  },
  10: {
    name: 'setNeedsFollowUp',
    payload_name: 'needsfollowup_set',
    colloquial: 'Set needs follow up',
  },
  11: {
    name: 'clearNeedsFollowUp',
    payload_name: 'needsfollowup_clear',
    colloquial: 'Clear needs follow up',
  },
}

export const taskTypeNameToColloquialMap = {
  email: {
    name: 'email',
    payload_name: 'send_email',
    colloquial: 'Send email',
  },
  sms: { name: 'sms', payload_name: 'send_sms', colloquial: 'Send text' },
  groupAdd: {
    name: 'groupAdd',
    payload_name: 'add_contacts_to_group',
    colloquial: 'Add contacts to group',
  },
  groupRemove: {
    name: 'groupRemove',
    payload_name: 'remove_contacts_from_group',
    colloquial: 'Remove contacts from group',
  },
  groupMove: {
    name: 'groupMove',
    payload_name: 'move_contacts_btwn_groups',
    colloquial: 'Move contacts between groups',
  },
  reassignContact: {
    name: 'reassignContact',
    payload_name: 'reassign_contact',
    colloquial: 'Reassign contact',
  },
  removeContactFromCampaign: {
    name: 'removeContactFromCampaign',
    payload_name: 'remove_contact_from_campaign',
    colloquial: 'Remove Contact from Campaign',
  },
  httpSendData: {
    name: 'httpSendData',
    payload_name: 'http_send_data',
    colloquial: 'HTTP Post',
  },
  setNeedsFollowUp: {
    name: 'setNeedsFollowUp',
    payload_name: 'needsfollowup_set',
    colloquial: 'Set needs follow up',
  },
  clearNeedsFollowUp: {
    name: 'clearNeedsFollowUp',
    payload_name: 'needsfollowup_clear',
    colloquial: 'Clear needs follow up',
  },
}
